<template>
  <li
    v-if="question"
    class="mt-4"
  >
    <p
      class="header"
      :class="{ required: question.required }"
    >
      {{ question.label }}
    </p>
    <v-textarea
      v-model="infoForLawyer"
      v-validate="{ ...regularLongText(question.required) }"
      :placeholder="$t('placeholders.add_text')"
      :error-messages="errors.collect('infoForLawyer')"
      data-vv-as=" "
      data-vv-name="infoForLawyer"
      :required="question.required"
      :disabled="readOnly"
      auto-grow
    />
  </li>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'specialistPackage/getLawyersData',
    mutationType: 'specialistPackage/updateLawyersData'
});
export default {
    name: 'InfoForLawyer',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        question () {
            return this.$store.getters['specialistPackage/getQuestions'].info_for_lawyer;
        },
        ...mapFields(['infoForLawyer'])
    }
};
</script>

<style scoped></style>
